import { render, staticRenderFns } from "./SpellCarousel.vue?vue&type=template&id=2da1d22b&scoped=true&"
import script from "./SpellCarousel.vue?vue&type=script&lang=js&"
export * from "./SpellCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpellCarousel.vue?vue&type=style&index=0&id=2da1d22b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1d22b",
  null
  
)

export default component.exports